var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "낙찰 수수료 안내",
      "width": "880"
    },
    on: {
      "open": _vm.init
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        return [_c('p', {
          staticClass: "font-size-14 font-size-md-16"
        }, [_vm._v(" 현재가 기준 "), _c('strong', {
          staticClass: "font-size-16 font-size-md-20 pl-8"
        }, [_vm._v(_vm._s(_vm.commission) + "원")])]), _c('div', {
          staticClass: "mt-6 mt-md-10"
        }, [_c('v-card', {
          staticClass: "grey-ef",
          attrs: {
            "tile": "",
            "elevation": "0"
          }
        }, [_c('v-card-text', {
          staticClass: "pa-16 pa-md-24"
        }, [_c('ul', {
          staticClass: "dot-list"
        }, [_c('li', [_vm._v("KATA 옥션의 낙찰 수수료는 5%입니다.")]), _c('li', [_vm._v("위의 수수료는 낙찰가격과 상관없이 일괄 적용합니다.")])])])], 1)], 1), _c('div', {
          staticClass: "mt-6 mt-md-10"
        }, [_c('auction-commission-table')], 1)];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }